/**
 * useHeroContext — single source of truth for the adaptive dashboard
 * hero (Feb 2026 retention overhaul). Wraps the
 * `GET /api/dashboard/hero-context` endpoint with TanStack Query so
 * every consumer (StreakHero, ResumeCard, Dashboard greeting, the
 * collapsed-onboarding chip) shares one network round-trip.
 *
 * staleTime = 60s — context only changes on streak/exam/onboarding
 * updates which are bounded by user action, so a one-minute cache is
 * more than enough to avoid duplicate fetches across mounts.
 */
import { useQuery } from '@tanstack/react-query';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const useHeroContext = () => {
  return useQuery({
    queryKey: ['dashboard', 'hero-context'],
    queryFn: async () => (await axios.get(`${API}/dashboard/hero-context`)).data,
    staleTime: 60_000,
    refetchOnWindowFocus: false,
  });
};

export const useResumeItem = () => {
  return useQuery({
    queryKey: ['dashboard', 'resume'],
    queryFn: async () => (await axios.get(`${API}/dashboard/resume`)).data,
    staleTime: 60_000,
    refetchOnWindowFocus: false,
  });
};
